import fetch from '../../api/fetch'

/**
 * 	Action to post data for step00
 *
 *  @param  {object} content [Body to be sent with step00 content]
 *  @param  {string} URL [/quotes/step00]
 * 	@method POST
 */
export function setStep01 (content: any) {
    return {
        type    : 'SET_STEP01',
        payload : {},
        content : content,
    }
}

/**
 * 	Action to post data for step00
 *
 *  @param  {object} content [Body to be sent with step00 content]
 *  @param  {string} URL [/quotes/step00]
 * 	@method POST
 */
export function setStep01Renewals (content: any) {
    return {
        type    : 'SET_STEP01_RENEWAL',
        payload : fetch(`/renewal/step01`, { method: 'POST', body: content }),
        quoteId : content.quote.id,
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/actions/quote/step01.ts